
import React from 'react';
import Home from './pages/Home';
import"./assets/scss/main.scss"
const App = () => {
  return (
    <div>
      <Home />
    </div>
  );
};

export default App;
